module.exports = __webpack_public_path__ + "img/books-stack-of-three-blue.06235def.svg";